<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	height="100%"
	fill="currentColor"
	version="1.1"
	viewBox="0 0 20 20"
	width="100%"
	fill-rule="evenodd"
	clip-rule="evenodd"
	class={classes('w-6 h-6 ', additionalClass)}
	><use xlink:href="#ytp-id-50" />
	<path
		d="M5.83384 11.7655C5.68386 11.6155 5.59961 11.4121 5.59961 11.1999C5.59961 10.9878 5.68386 10.7844 5.83384 10.6343L8.46824 7.99994L5.83384 5.36554C5.68811 5.21465 5.60748 5.01257 5.6093 4.80281C5.61112 4.59306 5.69526 4.39241 5.84358 4.24408C5.99191 4.09575 6.19256 4.01162 6.40232 4.0098C6.61208 4.00797 6.81416 4.08861 6.96504 4.23434L10.165 7.43434C10.315 7.58436 10.3993 7.7878 10.3993 7.99994C10.3993 8.21207 10.315 8.41551 10.165 8.56554L6.96504 11.7655C6.81502 11.9155 6.61157 11.9998 6.39944 11.9998C6.18731 11.9998 5.98386 11.9155 5.83384 11.7655Z"
	/>
</svg>
